export type ConnectionIssueKind = "offline" | "connection" | null;

// Note: resolves which (if any) connection banner to show. Offline takes
// precedence so only a single banner ever appears, even when SignalR is also
// down; a SignalR/live-connection problem is only relevant once authenticated.
export function resolveConnectionIssueKind(opts: {
  isOnline: boolean;
  isAuthenticated: boolean;
  isReconnecting: boolean;
  hasConnectionError: boolean;
}): ConnectionIssueKind {
  if (!opts.isOnline) return "offline";
  if (opts.isAuthenticated && (opts.isReconnecting || opts.hasConnectionError)) return "connection";
  return null;
}
